define(['lodash', 'santa-components', 'santa-core-utils', 'componentsCore', 'coreUtils', 'formCommon/bi/errors', 'formCommon/bi/events', 'reactDOM', 'prop-types'], function (_, santaComponents, coreUtilsLib, componentsCore, coreUtils, biErrors, biEvents, ReactDOM, PropTypes) {
    'use strict';
    const cookieUtils = coreUtils.cookieUtils,
        dateTimeUtils = coreUtils.dateTimeUtils,
        ajax = coreUtils.ajaxLibrary;
    const WIX_CLIENT_COOKIE = 'wixClient';

    const FIELD_TYPE_TO_ACTIVITY_TYPE = {
        name: 'firstName',
        secondaryEmail: 'email',
        customField: 'additional'
    };

    function createMessageStructure(fromEmail, fromName, toEmail, bccEmail, mailSubject, metaSiteId, // eslint-disable-line complexity
        message, contactPhone, formSubject, contactAddress, sendContactFormEmailsViaPong) {
        if (sendContactFormEmailsViaPong) {
            return {
                'metaSiteId': metaSiteId || 'dc853130-4fb2-464f-878d-3b6667dc4f97',
                'to': [
                    {
                        address: toEmail,
                        name: toEmail
                    }
                ],
                'bcc': bccEmail ? {address: bccEmail, name: bccEmail} : null,
                'from': {
                    address: fromEmail,
                    name: fromName

                },
                contactPhone,
                contactAddress,
                formSubject,
                'formMessage': message
            };
        }

        // Fallback to old message structure
        return {
            'to': [
                {
                    address: toEmail,
                    personal: toEmail
                }
            ],
            'bcc': bccEmail ? [
                {
                    address: bccEmail || 'n/a',
                    personal: bccEmail || 'n/a'
                }
            ] : [],
            'cc': [],
            'from': {
                address: fromEmail,
                personal: fromName
            },
            'subject': mailSubject,
            'metaSiteId': metaSiteId || 'dc853130-4fb2-464f-878d-3b6667dc4f97',
            'plainTextMessage': 'n/a'
        };
    }

    function createHtmlMessage(fields, websiteUrl, isPremium, formName) {
        const date = new Date(),
            templates = {
                todayDate: '<%=todayDay%> <%=todayMonthName%>, <%=todayYear%>',
                singleField: '<li style="list-style: none; margin: 0 0 5px 0; padding: 0;white-space: pre-wrap;"><b><%=fieldKey%></b> <%=fieldValue%></li>',
                outerMessage: `${'<ul style="list-style: none; margin: 0; padding: 0;">' +
                '<li style="list-style: none; margin: 0 0 5px 0; padding: 0;"><b><%=title%></b></li>' +
                '<li style="list-style: none; margin: 0 0 15px 0; padding: 0;"><%=via%> <%=websiteUrl%></li>' +
                '<li style="list-style: none; margin: 0 0 5px 0; padding: 0;"><b><%=details%></b></li>' +
                '<li style="list-style: none; margin: 0 0 25px 0; padding: 0;">' +
                '<ul style="margin: 0 0 0 20px; padding: 0;"><%=fields%></ul></li>'}${ 
                    formName ? '<li style="list-style: none; margin: 0 0 15px 0; padding: 0;"><b><%=formNameLabel%></b> <%=formName%></li>' : '' 
                }<li style="list-style: none; margin: 0 0 15px 0; padding: 0;"><b><%=sentOn%></b> <%=dateToday%></li>` +
                '<li style="list-style: none; margin: 0; padding: 0;"><%=thanks%></li></ul>'
            };

        return _.template(templates.outerMessage)({
            title: this.translatedKeys.title,
            via: this.translatedKeys.via,
            websiteUrl,
            details: this.translatedKeys.details,
            fields: _.reduce(fields, function (result, value, key) {
                return result + _.template(templates.singleField)({fieldKey: key, fieldValue: value});
            }, ''),
            sentOn: this.translatedKeys.sentOn,
            dateToday: _.template(templates.todayDate)({
                todayDay: date.getDate(),
                todayMonthName: dateTimeUtils.getMonthName(date.getMonth()),
                todayYear: date.getFullYear()
            }),
            formNameLabel: this.translatedKeys.formNameLabel,
            formName: formName || this.translatedKeys.formNameNoValuePlacholder,
            thanks: this.translatedKeys[`thanks${isPremium ? '_premium' : ''}`]
        });
    }
    function fetchAscendHtmlEmail(fields, websiteUrl, isPremium, formName) {
        const url = '/_api/crm-templates-server/contact-form/consume';
        const formNameObj = formName && !_.isEmpty(formName) ? {formName} : {};
        const data = _.merge(
            {
                'viaContactForm': 'via Contact Form',
                'aSiteVisitor': 'A site visitor',
                'neverMissALead': 'Never miss a lead.',
                'downloadThe': 'Download the',
                'wixMobileApp': 'Wix Mobile App',
                'desktopViewEditYourSettings': 'Edit your email settings',
                'mobileViewEditYourSettings': 'To edit your email settings, go to your Inbox on desktop.',
                'wixContactForm': 'Wix Contact Form',
                'to': 'to'
            },
            _.pick(this.translatedKeys,
                'viaContactForm',
                'aSiteVisitor',
                'details',
                'neverMissALead',
                'downloadThe',
                'wixMobileApp',
                'desktopViewEditYourSettings',
                'mobileViewEditYourSettings',
                'wixContactForm',
                'to'),
            {
                websiteUrl,
                metaSiteId: this.props.metaSiteId,
                fields: _.map(fields, (fieldValue, fieldKey) => ({fieldKey, fieldValue}))
            },
            formNameObj
        );
        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'x-wix-site-revision': this.props.siteRevision
            }
        }).then(response => {
            if (response.status === 200) {
                return response.text();
            }
            throw new Error(response.statusText);
        });
    }

    function extractCompDataId() {
        let res;
        const dataQuery = this.props.structure && this.props.structure.dataQuery;
        switch (dataQuery && typeof dataQuery) {
            case 'string':
                res = dataQuery;
                break;
            case 'object':
                res = dataQuery.id;
                break;
        }
        return (res || '').replace('#', '');
    }

    function createEmailMessage(isAscendEmail) { // eslint-disable-line complexity
        let message, fields;
        const isPremium = this.props.isPremiumUser;
        const fieldsModel = this.getFormFields.call(this);
        const toEmailAddress = this.props.compData.toEmailAddress;
        const bccEmailAddress = this.props.compData.bccEmailAddress;
        const fromName = this.getInputName();
        const metaSiteId = this.props.metaSiteId;
        const sendContactFormEmailsViaPong = this.props.isExperimentOpen('sendContactFormEmailsViaPong');
        const formName = this.props.compData.formName;

        if (fieldsModel.newModel) {
            const getValue = function (fieldType) {
                const field = fieldsModel.data.getAll(fieldType)[0] || {};
                return field.value;
            };
            fields = fieldsModel.data.displayed;
            message = createMessageStructure(
                getValue('email'),
                fromName,
                toEmailAddress,
                bccEmailAddress,
                `${this.translatedKeys[`subject${isPremium ? '_premium' : ''}`]} ${getValue('email')}`,
                metaSiteId,
                getValue('message'),
                getValue('phone'),
                getValue('subject'),
                getValue('address'),
                sendContactFormEmailsViaPong
            );
        } else {
            fields = fieldsModel;
            message = createMessageStructure(
                this.state.email.value,
                fromName,
                toEmailAddress,
                bccEmailAddress,
                `${this.translatedKeys[`subject${isPremium ? '_premium' : ''}`]} ${fieldsModel.email || fieldsModel.Email || fieldsModel[this.props.compData.emailFieldLabel]}`,
                metaSiteId,
                this.state.message && this.state.message.value,
                this.state.phone && this.state.phone.value,
                this.state.subject && this.state.subject.value,
                this.state.address && this.state.address.value,
                sendContactFormEmailsViaPong
            );
        }

        _.assign(message, {
            componentId: this.props.id,
            compDataId: extractCompDataId.call(this),
            pageId: _.isEmpty(this.props.compMasterPageData) ? this.props.pageId : 'masterPage',
            siteId: this.props.siteId
        });

        if (!sendContactFormEmailsViaPong) {
            if (isAscendEmail) {
                return fetchAscendHtmlEmail.call(this, fields, this.props.externalBaseUrl || '', isPremium, formName).then(htmlMessage => {
                    message.htmlMessage = htmlMessage;
                    return message;
                }).catch(() => {
                    message.htmlMessage = createHtmlMessage.call(this, fields, this.props.externalBaseUrl || '', isPremium, formName);
                    return message;
                });
            }
            message.htmlMessage = createHtmlMessage.call(this, fields, this.props.externalBaseUrl || '', isPremium, formName);
            return message;
        }

        message.fields = fields;
        return message;
    }

    const COMMON_SERVICES_NOTIFICATION_PATH = '/_api/wix-common-services-webapp/notification/invoke';
    const FALLBACK_HOST = 'https://fallback.wix.com';
    const PONG_PATH = '/_api/crm-inbox-server/pong/message';
    const FORM_BUILDER_PATH = '_api/wix-forms/v1/submit-contact-form';

    function getSendMailEndpointUrl(externalBaseUrl, sendContactFormEmailsViaPong) {
        const sendMessageEndpoint = sendContactFormEmailsViaPong ? PONG_PATH : COMMON_SERVICES_NOTIFICATION_PATH;

        //TODO: in preview mode, make changes to this.endpoint (need to add params: wixSession cookie, secured)
        if (!externalBaseUrl) { //preview
            const site = `${window.location.protocol}//${window.location.hostname}`;
            const cookie = cookieUtils.getCookie(WIX_CLIENT_COOKIE);
            const secured = 'Secured';
            const template = '{{site}}{{service}}{{secured}}?accept=json&contentType=json&appUrl={{site}}{{cookie}}';

            return template.replace(/\{\{site\}\}/g, site)
                .replace('{{service}}', sendMessageEndpoint)
                .replace('{{cookie}}', cookie)
                .replace('{{secured}}', secured);
        }

        const parsedUrl = coreUtils.urlUtils.parseUrl(externalBaseUrl);
        return `${parsedUrl.protocol}//${parsedUrl.host}${sendMessageEndpoint}?accept=json&contentType=json&appUrl=${parsedUrl.protocol}//${parsedUrl.hostname}`;
    }

    function getFallbackUrl() {
        return `${FALLBACK_HOST + COMMON_SERVICES_NOTIFICATION_PATH}?accept=json&contentType=json&appUrl=${FALLBACK_HOST}`;
    }

    function reportActivity(baseUrl, activityName, fields, activityInfo, fieldLabels) {
        const FormActivity = componentsCore.activityTypes[activityName];
        if (FormActivity) {
            componentsCore.activityService.reportActivity(baseUrl, new FormActivity(activityInfo, fields, fieldLabels));
        }
    }

    function shouldIgnoreActivity(props) {
        return props.ignoreActivityReport || props.isTemplate;
    }

    function handleSubmitMessage() {
        const successMessage = this.props.compData.successMessage || this.translatedKeys.successMessage;
        this.showMessage(successMessage);
    }

    function handleSubmitLink() {
        const successLink = this.props.compData.link;
        if (!successLink) {
            return;
        }

        const linkVal = coreUtils.linkRenderer.renderLink(successLink, this.props.linkRenderInfo, this.props.rootNavigationInfo);
        const successLinkData = coreUtils.wixUrlParser.parseUrl(this.props.linkRenderInfo, coreUtils.linkRenderer.getLinkUrlFromLinkProps(linkVal));
        if (!successLinkData) {
            return;
        }

        const anchorData = successLink.anchorDataId;
        _.assign(successLinkData, {anchorData});

        if (successLinkData.pageId === this.props.rootNavigationInfo.pageId) {
            if (anchorData) {
                this.props.scrollToAnchor(anchorData);
            }
        } else {
            this.props.navigateToPage(successLinkData);
        }
    }

    function countBy(arr, prop) {
        return (arr || []).reduce(function (acc, item) {
            return item[prop] ? acc + 1 : acc;
        }, 0);
    }

    function createFieldSkinId(field) {
        if (field.fieldType === 'message') {
            return 'fieldMessage';
        }
        return `field${field.index + 1}`;
    }

    function formBuilderSubmitActivity() {
        const {toEmailAddress, bccEmailAddress} = this.props.compData;
        const TAGGED_FIELDS = ['phone', 'address', 'date', 'website', 'email'];

        const createTag = field => _.includes(TAGGED_FIELDS, field.fieldType) ? {tag: 'main'} : {};
        const createField = field => ({
            value: field.fieldType === 'customField' ?
                {string: this.state[createFieldSkinId(field)].value} :
                this.state[createFieldSkinId(field)].value
        });

        const fields = _.reduce(this.props.orderedFields, (result, field) => {
            const isDisplayed = field.hidden;
            if (isDisplayed) {
                result.push({
                    label: field.fieldLabel,
                    [FIELD_TYPE_TO_ACTIVITY_TYPE[field.fieldType] || field.fieldType]: _.merge({}, createTag(field), createField(field))
                });
            }
            return result;
        }, []);

        const toEmailAddressField = {
            to: [{
                address: toEmailAddress || '',
                name: toEmailAddress || ''
            }]
        };

        const bccEmailAddressField = bccEmailAddress ? {
            bcc: [{
                address: bccEmailAddress,
                name: bccEmailAddress
            }]
        } : {};

        coreUtils.ajaxLibrary.ajax({
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url: `${this.props.activityInfo.baseUrl}/${FORM_BUILDER_PATH}`,
            headers: {
                'Authorization': `MSID.${this.props.metaSiteId}`,
                'x-wix-site-revision': this.props.siteRevision
            },
            data: JSON.stringify(_.merge({}, {fields}, toEmailAddressField, bccEmailAddressField))
        });
    }

    function onSubmitSuccess(activityName) {
        coreUtils.integrations.promoteAnalytics.trackEvent(this.props.siteApiForPromoteAnalytics, 'Lead');

        this.retryCount = 0;
        this.props.reportBI(biEvents.FORM_SUBMIT_SUCCESS, {
            componentId: this.props.id,
            componentType: this.props.structure.componentType
        });

        this.setState({
            mailSent: true
        });

        if (this.props.compData.onSubmitBehavior === 'message') {
            handleSubmitMessage.call(this);
        } else {
            handleSubmitLink.call(this);
        }

        if (!shouldIgnoreActivity(this.props)) {
            if (this.props.isExperimentOpen('sv_contactFormUseFormBuilderSubmit') && this.getActivityName() !== 'SubscribeFormActivity') {
                formBuilderSubmitActivity.call(this);
            } else {
                reportActivity(this.props.activityInfo.baseUrl, activityName, this.getFieldsForActivityReporting(), this.props.activityInfo, this.getFieldLabels());
            }
        }

        cleanForm.call(this);
        this.isBusy = false;
    }

    const ERROR_STATUSES_TO_FALLBACK = ['abort', 'timeout'];

    function onSubmitError(response, status) { // eslint-disable-line complexity
        this.retryCount += 1;

        if (this.shouldSubmitFallbackRequest && _.includes(ERROR_STATUSES_TO_FALLBACK, status) && this.retryCount < 2) {
            const sendContactFormEmailsViaPong = this.props.isExperimentOpen('sendContactFormEmailsViaPong');
            const longerTimeoutsPong = this.props.isExperimentOpen('longer_timeouts_pong');
            const emailMessage = createEmailMessage.call(this);

            performSubmit.call(
                this,
                getSendMailEndpointUrl(this.props.externalBaseUrl || '', sendContactFormEmailsViaPong),
                emailMessage,
                onSubmitSuccess.bind(this, this.getActivityName()),
                onSubmitError.bind(this),
                getMessageTimeout(longerTimeoutsPong)
            );
        } else if (this.shouldSubmitFallbackRequest && _.includes(ERROR_STATUSES_TO_FALLBACK, status) && this.retryCount > 1) {
            this.props.reportBI(biErrors.FORM_SUBMIT_FAILURE, {
                componentId: this.props.id,
                componentType: this.props.structure.componentType,
                errorDesc: 'Unspecified error occurred, possibly a connection problem, fallback activated',
                response: JSON.stringify(response)
            });
            submitFallbackRequest.call(this);
        } else {
            this.props.reportBI(biErrors.FORM_SUBMIT_FINAL_FALLBACK, {
                componentId: this.props.id,
                componentType: this.props.structure.componentType,
                errorDesc: 'Error occurred in Fallback Request',
                response: JSON.stringify(response)
            });

            this.setState({
                mailSent: false
            });
            this.showMessage(this.translatedKeys.error, true);

            this.isBusy = false;
        }
    }

    function cleanForm() {
        this.setState(this.getCleanFormState());
    }

    function getMessageTimeout(longer_timeouts_pong) {
        return longer_timeouts_pong ? 30000 : 8000;
    }

    function onSubmit(e) { // eslint-disable-line complexity
        e.preventDefault();
        this.retryCount = 0;
        if (this.shouldBlockSubmit && this.shouldBlockSubmit()) {
            this.blockSubmit(ReactDOM.findDOMNode(this));
            return;
        }
        reportCrmBi.call(this, biEvents.CONTACT_FORM_CLICK_SUBMIT, {isDynamic: this.props.isDynamicContactForm});
        const toEmail = this.props.compData.toEmailAddress;
        const isValidEmail = toEmail && toEmail !== 'a33012eff368a577d48f52f310c92140';
        if (!isValidEmail) {
            this.props.reportBI(biErrors.FORM_SUBMIT_INVALID_EMAIL, {email: toEmail});
        }
        const validationBiParams = {
            isDynamic: this.props.isDynamicContactForm,
            numOfFields: countBy(this.props.orderedFields, 'hidden'),
            numOfRequiredFields: countBy(this.props.orderedFields, 'required')
        };
        const isFormValid = this.isFormValid();
        const canSubmitNewRequest = !this.isBusy && isFormValid;
        if (canSubmitNewRequest) {
            this.props.reportBI(biEvents.FORM_SUBMIT, {
                componentId: this.props.id,
                componentType: this.props.structure.componentType
            });

            reportCrmBi.call(this, biEvents.CONTACT_FORM_SUBMIT_VALIDATION_SUCCESS, validationBiParams);
            this.shouldSubmitFallbackRequest = true;
            this.isBusy = true;
            if (this.props.compData.onSubmitBehavior === 'message') {
                this.showMessage(this.translatedKeys.submitting);
            }

            const sendContactFormEmailsViaPong = this.props.isExperimentOpen('sendContactFormEmailsViaPong');
            const longerTimeoutsPong = this.props.isExperimentOpen('longer_timeouts_pong');
            const isAscendEmail = this.props.isExperimentOpen('sv_contactFormAscendEmail');
            const emailMessage = createEmailMessage.call(this, isAscendEmail);
            if (isAscendEmail) {
                preformSubmitWithAsyncMessage.call(
                    this,
                    getSendMailEndpointUrl(this.props.externalBaseUrl || '', sendContactFormEmailsViaPong),
                    emailMessage,
                    onSubmitSuccess.bind(this, this.getActivityName()),
                    onSubmitError.bind(this),
                    getMessageTimeout(longerTimeoutsPong)
                );
            } else {
                performSubmit.call(
                    this,
                    getSendMailEndpointUrl(this.props.externalBaseUrl || '', sendContactFormEmailsViaPong),
                    emailMessage,
                    onSubmitSuccess.bind(this, this.getActivityName()),
                    onSubmitError.bind(this),
                    getMessageTimeout(longerTimeoutsPong)
                );
            }
        } else if (!isFormValid) {
            reportCrmBi.call(this, biEvents.CONTACT_FORM_SUBMIT_VALIDATION_FAILURE, validationBiParams);
        }
    }

    function performSubmit(url, emailMessage, onSuccess, onError, timeout) {
        ajax.ajax({
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url,
            headers: {
                'x-wix-site-revision': this.props.siteRevision
            },
            data: JSON.stringify(emailMessage),
            success: onSuccess,
            error: onError,
            timeout
        });
    }

    function preformSubmitWithAsyncMessage(url, asyncEmailMessage, onSuccess, onError, timeout) {
        asyncEmailMessage.then(emailMessage =>
            ajax.ajax({
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                url,
                headers: {
                    'x-wix-site-revision': this.props.siteRevision
                },
                data: JSON.stringify(emailMessage),
                success: onSuccess,
                error: onError,
                timeout
            }));
    }

    function submitFallbackRequest() {
        this.shouldSubmitFallbackRequest = false;
        const emailMessage = createEmailMessage.call(this);
        ajax.ajax({
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            url: getFallbackUrl(),
            headers: {
                'x-wix-site-revision': this.props.siteRevision
            },
            data: JSON.stringify(emailMessage),
            success: onSubmitSuccess.bind(this, this.getActivityName()),
            error: onSubmitError.bind(this)
        });
    }

    function reportCrmBi(event, params) {
        if (this.props.biVisitorId) {
            this.props.reportBI(event, _.merge(params, {visitorId: this.props.biVisitorId}));
        }
    }

    /*

     The following functions must be implemented in a form component in order to use formMixin:
     getFormInitialState,
     getFormSkinProperties,
     getFormFields,
     getFieldsForActivityReporting,
     getFieldLabels,
     isFormValid,
     getActivityName,
     getInputName,
     getLangKeys

     */
    return {
        mixins: [componentsCore.mixins.skinBasedComp, coreUtilsLib.timersMixins.timeoutsMixin],

        propTypes: {
            compMasterPageData: santaComponents.santaTypesDefinitions.ContactFormSantaTypes.compMasterPageData,
            siteApiForPromoteAnalytics: santaComponents.santaTypesDefinitions.ContactFormSantaTypes.siteApiForPromoteAnalytics,
            id: santaComponents.santaTypesDefinitions.Component.id.isRequired,
            pageId: santaComponents.santaTypesDefinitions.Component.pageId.isRequired,
            siteId: santaComponents.santaTypesDefinitions.RendererModel.siteId.isRequired,
            structure: santaComponents.santaTypesDefinitions.Component.structure.isRequired,
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            rootNavigationInfo: santaComponents.santaTypesDefinitions.Component.rootNavigationInfo.isRequired,
            shouldResetComponent: santaComponents.santaTypesDefinitions.RenderFlags.shouldResetComponent.isRequired,
            contactFormTranslations: santaComponents.santaTypesDefinitions.ContactFormSantaTypes.contactFormTranslations.isRequired,
            isMobileView: santaComponents.santaTypesDefinitions.isMobileView.isRequired,
            isPremiumUser: santaComponents.santaTypesDefinitions.isPremiumUser.isRequired,
            isTemplate: santaComponents.santaTypesDefinitions.isTemplate.isRequired,
            metaSiteId: santaComponents.santaTypesDefinitions.RendererModel.metaSiteId.isRequired,
            externalBaseUrl: santaComponents.santaTypesDefinitions.PublicModel.externalBaseUrl,
            scrollToAnchor: santaComponents.santaTypesDefinitions.scrollToAnchor.isRequired,
            navigateToPage: santaComponents.santaTypesDefinitions.navigateToPage.isRequired,
            reportBI: santaComponents.santaTypesDefinitions.reportBI.isRequired,
            linkRenderInfo: santaComponents.santaTypesDefinitions.Link.renderInfo.isRequired,
            activityInfo: santaComponents.santaTypesDefinitions.Activity.activityInfo,
            ignoreActivityReport: PropTypes.bool,
            isExperimentOpen: santaComponents.santaTypesDefinitions.isExperimentOpen,
            isDynamicContactForm: santaComponents.santaTypesDefinitions.ContactFormSantaTypes.isDynamicContactForm.isRequired,
            userLanguage: santaComponents.santaTypesDefinitions.WixUserSantaTypes.userLanguage.isRequired,
            biVisitorId: santaComponents.santaTypesDefinitions.biVisitorId,
            siteRevision: santaComponents.santaTypesDefinitions.PublicModel.siteRevision
        },

        getInitialState() {
            this.shouldResetFields = this.props.shouldResetComponent;
            this.translatedKeys = this.getLangKeys(this.props.contactFormTranslations);
            this.translatedKeys.submitting = '…';
            return _.merge(this.getFormInitialState(), {
                $mob: this.props.isMobileView ? 'mobile' : 'desktop',
                $dir: this.props.compData.textDirection || 'left'
            });
        },

        showMessage(message, isError) {
            this.setState({
                notifications: {
                    message,
                    error: !!isError
                }
            });
        },

        componentWillReceiveProps(nextProps) {
            const newShouldResetFields = this.props.shouldResetComponent;

            if (newShouldResetFields && newShouldResetFields !== this.shouldResetFields) {
                cleanForm.call(this);
            }
            this.shouldResetFields = newShouldResetFields;
            this.setState({
                $mob: nextProps.isMobileView ? 'mobile' : 'desktop',
                $dir: nextProps.compData.textDirection || 'left'
            });
        },

        getSkinProperties() {
            if (this.state.notifications.message) {
                this.registerReLayout();
            }
            return _.merge(this.getFormSkinProperties(this.translatedKeys), {
                submit: {
                    onClick: onSubmit.bind(this),
                    children: this.props.compData.submitButtonLabel || 'Send'
                }
            });
        }
    };
});
